




















import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class MenuEditProfileIcon extends Vue {
  @Prop({ default: 53 })
  width!: number;
  @Prop({ default: 53 })
  height!: number;
  @Prop({ default: "#FF5733" })
  color!: string;
}
